import React from 'react';
import styled from 'styled-components';
import ProjectIllustration from '^/assets/illustrations/illustration-project.svg';
import Button from '^/components/atoms/Button';
import colorTokens from '^/theme/colors/color-tokens';

const EmptyStateContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  padding: '2rem',
  borderRadius: '8px',
});

const EmptyStateTitle = styled.p({
  color: colorTokens.textGrayDark,
  fontSize: '20px',
  textAlign: 'center',
  marginBottom: '4px',
  lineHeight: '150%',
});
const EmptyStateSubTitle = styled.p({
  color: colorTokens.disabledGrayDark,
  marginBottom: '32px',
  textAlign: 'center',
  lineHeight: '20px',
  fontSize: '14px',
});

interface EmptyStateProps {
  title?: string;
  subTitle?: string;
  buttonText?: string;
  showButton?: boolean;
  onCreateClick?(): void;
  hasCreationRole?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  onCreateClick,
  title = '',
  buttonText = '',
  subTitle = '',
  hasCreationRole = false,
}) => (
  <EmptyStateContainer>
    <ProjectIllustration />
    <EmptyStateTitle>{title}</EmptyStateTitle>
    <EmptyStateSubTitle>{subTitle}</EmptyStateSubTitle>
    {hasCreationRole ? (
      <Button size="large" data-testid="empty-state-btn" onClick={onCreateClick}>
        {buttonText}
      </Button>
    ) : null}
  </EmptyStateContainer>
);

export default EmptyState;
